import AnimatedLottieView from 'lottie-react-native';

const carouselData = [
  {
    title: 'Your completed campaigns',
    caption: 'Quickly glance at your completed campaigns and see how they performed',
    image: <AnimatedLottieView source={require('@assets/animations/76113-chart-reports.json')} style={{ height: 100, width: 100, top: -10, flex: 1 }} loop autoPlay />

  },
  {
    title: 'Learn from your data',
    caption: 'Look at the data from your campaigns and see what you can learn from it',
    image: < AnimatedLottieView source={require('@assets/animations/chart_animation.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  },
  {
    title: "Reissue your best campaigns",
    caption: 'Easily reissue your best campaigns and see how they perform again',
    image: < AnimatedLottieView source={require('@assets/animations/share_animation.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  }
];

const dataCarouselData = [
  {
    title: 'Your Data is Safe',
    caption: 'Just fill out a few details and get going',
    image: < AnimatedLottieView source={require('@assets/animations/lockAnimation.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  },
  {
    title: 'Easily make new models',
    caption: 'Make models and share them with other users, or keep them private for your own use',
    image: < AnimatedLottieView source={require('@assets/animations/41291-human-resources-approval-animation.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  },
  {
    title: "And don't forget me!",
    caption: 'Your AI helper is always here to help you out with your data and models',
    image: < AnimatedLottieView source={require('@assets/animations/automation_robot.json')} style={{ height: 100, width: 100, flex: 1 }} loop autoPlay />
  },
]

export { carouselData, dataCarouselData };